import { render, staticRenderFns } from "./ModuleTabContainer.vue?vue&type=template&id=3b99d84a&scoped=true&"
import script from "./ModuleTabContainer.vue?vue&type=script&lang=ts&"
export * from "./ModuleTabContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleTabContainer.vue?vue&type=style&index=0&id=3b99d84a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b99d84a",
  null
  
)

export default component.exports